import {
  List, Datagrid, TextField, BooleanField, DateField, EditButton, Edit, Create, SimpleForm,
  TextInput, BooleanInput, DateTimeInput, required,
} from 'react-admin';
import { Stack } from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import { TiptapInput } from '../../components/TiptapInput.jsx';

const filters = [
  <TextInput key="q" source="q" label="Search" alwaysOn />,
];

const CareerList = () => (
  <List sort={{ field: 'postedAt', order: 'DESC' }} filters={filters} perPage={25}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="title" />
      <TextField source="section" />
      <TextField source="location" />
      <BooleanField source="isOpen" label="Open" />
      <DateField source="postedAt" label="Posted" />
      <EditButton />
    </Datagrid>
  </List>
);

const CareerForm = () => (
  <Stack spacing={2} sx={{ maxWidth: 800 }}>
    <TextInput source="title" validate={required()} fullWidth />
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextInput source="section" label="Section / department" fullWidth />
      <TextInput source="employmentType" label="Type (Full-time / Part-time / …)" fullWidth />
      <TextInput source="location" fullWidth />
    </Stack>
    <TiptapInput source="description" label="Description" />
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <BooleanInput source="isOpen" label="Currently open" defaultValue={true} />
      <DateTimeInput source="postedAt" label="Posted at" />
    </Stack>
  </Stack>
);

const CareerEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><CareerForm /></SimpleForm>
  </Edit>
);
const CareerCreate = () => (
  <Create redirect="list">
    <SimpleForm><CareerForm /></SimpleForm>
  </Create>
);

export default {
  list: CareerList,
  edit: CareerEdit,
  create: CareerCreate,
  icon: WorkIcon,
  options: { label: 'Careers' },
  recordRepresentation: 'title',
};
